import React from 'react';

// import { Container } from './styles';

const CapPay = () => {
  return <div>CapPay</div>;
};

export default CapPay;
